import axios from 'axios';

export const getBlogPosts = async () => {
    try {
        const wpCategories = process.env.REACT_APP_WP_CATEGORIES;
        const response = await axios.get(
            `${process.env.REACT_APP_WP_API_URL_V2}/posts`,
            {
                    params: {
                        per_page: 100,
                        _fields: [
                            'id',
                            'categories',
                            'title',
                            'date',
                            'featured_media',
                            'slug',
                            'author_info',
                            'status'
                        ],
                        status: 'publish',
                        categories: wpCategories
                    }
            });
        const posts = response.data;
        return Array.isArray(posts) ? posts : [];
    } catch (error) {
        console.error('Erreur lors de la récupération des articles :', error);
        return [];
    }
};

